import Vue from 'vue';
import { commonTransfersHistoryTablesMixin } from '@/components/pages/transfersPage/components/transfersHistory/mixins/index';
export default Vue.extend({
    name: 'outerTransfersTable',
    props: {
        items: {
            type: Array,
            required: true
        },
        nextPage: {
            type: Number
        }
    },
    mixins: [
        commonTransfersHistoryTablesMixin
    ],
    data() {
        return {
            headers: [
                {
                    id: 1,
                    switched: true,
                    text: this.$t('transfersPage.history.outerTable.recipient'),
                    align: 'start',
                    sortable: true,
                    value: 'recipient',
                    width: 140,
                    priority: 1
                },
                {
                    id: 2,
                    switched: true,
                    text: this.$t('transfersPage.history.outerTable.datetime'),
                    align: 'start',
                    sortable: true,
                    value: 'datetime',
                    width: 120,
                    priority: 2
                },
                {
                    id: 3,
                    switched: true,
                    text: this.$t('transfersPage.history.outerTable.amount'),
                    align: 'end',
                    sortable: true,
                    value: 'amount',
                    width: 184,
                    priority: 1
                },
                {
                    id: 4,
                    switched: true,
                    text: this.$t('transfersPage.history.outerTable.asset'),
                    align: 'start',
                    sortable: true,
                    value: 'asset',
                    width: 80,
                    priority: 1
                },
                {
                    id: 5,
                    switched: true,
                    text: this.$t('transfersPage.history.outerTable.network'),
                    align: 'start',
                    sortable: true,
                    value: 'network',
                    width: 60,
                    priority: 1
                },
                {
                    id: 6,
                    switched: true,
                    text: this.$t('transfersPage.history.outerTable.status'),
                    align: 'start',
                    sortable: true,
                    value: 'status',
                    width: 0,
                    priority: 1
                },
                {
                    id: 7,
                    switched: true,
                    text: this.$t('transfersPage.history.outerTable.transaction'),
                    align: 'center',
                    sortable: true,
                    value: 'link',
                    width: 111,
                    priority: 1
                }
            ],
            sorting: '',
            isDescSort: false,
            scrolledDown: false
        };
    },
    methods: {
        statusText(status) {
            switch (status) {
                case 1:
                    return this.$t('transfersPage.history.outerTable.transferCreated');
                case 2:
                    return this.$t('transfersPage.history.outerTable.transferProgress');
                case 3:
                    return this.$t('transfersPage.history.outerTable.transferSuccess');
                case 5:
                    return this.$t('transfersPage.history.outerTable.transferAml');
                default:
                    return this.$t('transfersPage.history.outerTable.transferError');
            }
        },
        iconByStatus(status) {
            switch (status) {
                case 1:
                    return 'transfer-created';
                case 2:
                    return 'transfer-progress';
                case 3:
                    return 'transfer-success';
                default:
                    return 'transfer-error';
            }
        }
    },
    computed: {
        headersByPriority() {
            const vm = this;
            let currPriority = 4;
            if (vm.$root.windowWidth <= 960 && vm.$root.windowWidth >= 768)
                currPriority = 3;
            if (vm.$root.windowWidth < 768 && vm.$root.windowWidth >= 516)
                currPriority = 2;
            if (vm.$root.windowWidth < 516)
                currPriority = 1;
            const headers = vm.headers.reduce((acc, curr) => {
                if (curr.priority <= currPriority) {
                    if (currPriority === 1) {
                        if (curr.value === 'recipient') {
                            curr.width = 76;
                        }
                        if (curr.value === 'amount') {
                            curr.width = 0;
                        }
                        if (curr.value === 'asset') {
                            curr.width = 40;
                            curr.text = '';
                        }
                        if (curr.value === 'network') {
                            curr.width = 40;
                        }
                        if (curr.value === 'status') {
                            curr.width = 24;
                            curr.text = '';
                        }
                        if (curr.value === 'link') {
                            curr.width = 20;
                            curr.text = '';
                        }
                    }
                    else if (currPriority === 2) {
                        if (curr.value === 'recipient') {
                            curr.width = 82;
                        }
                        if (curr.value === 'datetime') {
                            curr.width = 106;
                        }
                        if (curr.value === 'amount') {
                            curr.width = 84;
                        }
                        if (curr.value === 'asset') {
                            curr.width = 48;
                            curr.text = '';
                        }
                        if (curr.value === 'network') {
                            curr.width = 40;
                        }
                        if (curr.value === 'status') {
                            curr.width = 90;
                            curr.text = this.$t('transfersPage.history.outerTable.status');
                        }
                        if (curr.value === 'link') {
                            curr.width = 20;
                            curr.text = '';
                        }
                    }
                    else if (currPriority === 3) {
                        if (curr.value === 'recipient') {
                            curr.width = 172;
                        }
                        if (curr.value === 'datetime') {
                            curr.width = 108;
                        }
                        if (curr.value === 'amount') {
                            curr.width = 162;
                        }
                        if (curr.value === 'asset') {
                            curr.width = 48;
                            curr.text = '';
                        }
                        if (curr.value === 'network') {
                            curr.width = 40;
                        }
                        if (curr.value === 'status') {
                            curr.width = 0;
                            curr.text = this.$t('transfersPage.history.outerTable.status');
                        }
                        if (curr.value === 'link') {
                            curr.width = 111;
                            curr.text = this.$t('transfersPage.history.outerTable.transaction');
                        }
                    }
                    else {
                        if (curr.value === 'recipient') {
                            curr.width = 120;
                        }
                        if (curr.value === 'datetime') {
                            curr.width = 120;
                        }
                        if (curr.value === 'amount') {
                            curr.width = 130;
                        }
                        if (curr.value === 'asset') {
                            curr.width = 65;
                            curr.text = this.$t('transfersPage.history.outerTable.asset');
                        }
                        if (curr.value === 'network') {
                            curr.width = 50;
                        }
                        if (curr.value === 'status') {
                            curr.width = 0;
                            curr.text = this.$t('transfersPage.history.outerTable.status');
                        }
                        if (curr.value === 'link') {
                            curr.width = 111;
                            curr.text = this.$t('transfersPage.history.outerTable.transaction');
                        }
                    }
                    acc.push(curr);
                }
                return acc;
            }, []);
            return headers;
        }
    },
    mounted() {
        // const vm = this as any
        // const { thead, tbody } = vm.$refs
        // function setSameWidth () {
        //   const tbodyCells = tbody.$el.querySelectorAll('tbody tr:first-of-type td')
        //   const theadCells = thead.$el.querySelectorAll('thead tr th')
        //   if (tbodyCells) {
        //     for (let i = 0; i < tbodyCells.length; i++) {
        //       let width = parseFloat(window.getComputedStyle(theadCells[i]).maxWidth)
        //       if (width > 200) width = 200
        //       theadCells[i].setAttribute('width', width)
        //       tbodyCells[i].setAttribute('width', width)
        //       tbodyCells[i].style.width = width + 'px'
        //       tbodyCells[i].style.maxWidth = width + 'px'
        //       tbodyCells[i].style.minWidth = width + 'px'
        //     }
        //   }
        // }
        // if (window.innerWidth > 767 && vm.items.length) {
        //   setSameWidth()
        //   const tbodyObserver = new MutationObserver(setSameWidth)
        //   tbodyObserver.observe(thead.$el, {
        //     childList: true,
        //     subtree: true,
        //     characterData: true
        //   })
        //   window.addEventListener('resize', setSameWidth)
        // }
    }
});
